import cn from 'classnames';
import React, { createElement, memo, useCallback, useMemo } from 'react';

import { valueIsNumber } from 'utils/typeChecking';

import sm from './styles.module.scss';

interface Props {
  content: string | undefined;
  withWhiteColor?: boolean;
  withGreyColor?: boolean;
  withRedColor?: boolean;
  with10Font?: boolean;
  with12Font?: boolean;
  with14Font?: boolean;
  with15Font?: boolean;
  with16Font?: boolean;
  with17Font?: boolean;
  with18Font?: boolean;
  with20Font?: boolean;
  with24Font?: boolean;
  with30Font?: boolean;
  with36Font?: boolean;
  with48Font?: boolean;
  withMediumWeight?: boolean;
  withSemiBoldWeight?: boolean;
  withBoldWeight?: boolean;
  withCapitalize?: boolean;
  withUpperCase?: boolean;
  withBlueColor?: boolean;
  withGreenColor?: boolean;
  withEllipsis?: boolean;
  withPreLine?: boolean;
  withMargin?: boolean;
  isDisabled?: boolean;
  asBlock?: boolean;
  href?: string;
  someProp?: {} | Function;
  charLimit?: number;
  withUnderline?: boolean;
  noWrap?: boolean;
}

export const Text = ({ content, href, charLimit, ...classes }: Props) => {
  const classNames = useMemo(
    () =>
      cn(
        sm.Base,
        Object.entries(classes)
          .filter(([, value]) => value)
          .reduce((acc, [key, value]) => ({ ...acc, [sm[key]]: value }), {})
      ),
    [classes]
  );

  const trimmedContent = useMemo(
    () =>
      valueIsNumber(charLimit) && !!content
        ? content.length > charLimit
          ? `${content.substring(0, charLimit - 1)}...`
          : content
        : content,
    [charLimit, content]
  );

  const NodeToRender = useCallback(
    () =>
      href
        ? createElement('a', { className: classNames, href }, trimmedContent)
        : createElement('span', { className: classNames }, trimmedContent),
    [classNames, href, trimmedContent]
  );

  return <NodeToRender />;
};

export default memo(Text);
